import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import type { LocaleCode } from '@sshop/domain';

import { useLocale } from '@/shared/hooks/useLocale';

export function useSwitchLanguage(): {
  current: LocaleCode;
  next: LocaleCode;
  switchTo: () => void;
} {
  const current = useLocale();
  const next = current === 'ge' ? 'en' : 'ge';
  const location = useLocation();
  const navigate = useNavigate();

  const switchTo = useCallback(() => {
    const segments = location.pathname.split('/').filter(Boolean);
    if (segments.length > 0 && (segments[0] === 'ge' || segments[0] === 'en')) {
      segments[0] = next;
    } else {
      segments.unshift(next);
    }
    navigate({ pathname: '/' + segments.join('/'), search: location.search, hash: location.hash });
  }, [location.hash, location.pathname, location.search, navigate, next]);

  return { current, next, switchTo };
}
